import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentReferenceType, StudentDebtType } from '../../../types/Finance';

const initialState:PaymentReferenceType = {
  idStudent: '',
  idPaymentType: '',
  amount: 0,
  dueDate: '',
  referenceCode: ''
}

const paymentReferenceSlice = createSlice({
  name: "paymentReference",
  initialState,
  reducers: {
    setPaymentReferenceData:(state, action:PayloadAction<PaymentReferenceType>)=>({...state, ...action.payload}), 
    resetPaymentReferenceData :()=>({...initialState})
  }
});

export const {setPaymentReferenceData,resetPaymentReferenceData} = paymentReferenceSlice.actions

export default paymentReferenceSlice.reducer